import { EngravingConfigs } from './product';

export interface CartItem {
  identifier: number;
  quantity: number;
  product: CartItemProduct;
  productGrouping: CartItemProductGrouping;
  itemOptions: ItemOptions;
  bundle: any;
  productBundle: any;
  customerPlacement: string;
  deliveryExpectation: string;
  shortDeliveryExpectation: string;
  retailerName: string;
  supplierName?: string;
  deliveryMethod: string;
  engravingConfigs?: EngravingConfigs;
}

export enum ItemOptionType {
  Unknown = 0,
  GiftCard = 1,
  Engraving = 2,
}

export interface ItemOptions {
  type: ItemOptionType;
  message?: string;
  sender?: string;
  recipients?: string[];
  sendDate?: string;
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  price?: number | string;
}

export interface CartItemProduct {
  id: number;
  price: number;
  originalPrice: number;
  inStock: number;
  containerType: string;
  subgroupId: string;
  volume: string;
  shortPackSize: string;
  shortVolume: string;
  thumbUrl: string;
  imageUrl: string;
  permalink: string;
  supplierId: number;
  productId: number;
  deals: any[];
  twoForOne: any;
  upc: string;
  overridable: boolean;
  sku: string;
  customPromo: any;
  productPermalink: string;
  preSaleExpectation: any;
  weight: any;
  engravingLocation: string;
}

export interface CartItemProductGrouping {
  id: number;
  name: string;
  productName: string;
  description: string;
  tags: string[];
  type: string;
  category: string;
  brand: string;
  hierarchyCategory: HierarchyCategory;
  hierarchyType: HierarchyType;
  hierarchySubtype: HierarchySubtype;
  brandData: BrandData;
  thumbUrl: string;
  imageUrl: string;
  properties: Property[];
  permalink: string;
  productContent: boolean;
  variants: CartItemVariant[];
  externalProducts: any[];
  supplierId: number;
  deals: any[];
  browseType: string;
  productGroupingPermalink: string;
}

export interface HierarchyCategory {
  permalink: string;
  name: string;
}

export interface HierarchyType {
  permalink: string;
  name: string;
}

export interface HierarchySubtype {
  permalink: string;
  name: string;
}

export interface BrandData {
  permalink: string;
  name: string;
}

export interface Property {
  name: string;
  value: string;
}

export interface CartItemVariant {
  id: number;
  price: number;
  originalPrice: number;
  inStock: number;
  containerType: string;
  subgroupId: string;
  volume: string;
  shortPackSize: string;
  shortVolume: string;
  thumbUrl: string;
  imageUrl: string;
  permalink: string;
  supplierId: number;
  productId: number;
  deals: any[];
  twoForOne: any;
  upc: string;
  overridable: boolean;
  sku: string;
  customPromo: any;
  productPermalink: string;
  preSaleExpectation: any;
  weight: any;
  engravingLocation?: string;
}
